var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShirt = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.2 2.14 2.93 5.06c-.62.28-.9 1-.62 1.62l2.07 4.54v9.52c0 .61.51 1.12 1.12 1.12h13c.61 0 1.12-.51 1.12-1.12v-9.52l2.07-4.54c.28-.62 0-1.34-.62-1.62L14.8 2.14"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.2 2.14 2.8 3.7 2.8-3.7M12 5.84v7.62"
}))));
SvgShirt.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgShirt);
export default ForwardRef;